// 不同项目特殊引用的路由文件
//  cctv 路由
// 平台登录页：通过登录页登录
const PlatfromLoginIndex = () =>
  import(
    /* webpackChunkName: "platfromLoginIndex" */ '@platfrom/login/cctv_login.vue'
  )
// 平台登录页：通过接口跳转登录
const PlatfromLoginJumpIndex = () =>
  import(
    /* webpackChunkName: "platfromLoginJumpIndex" */ '@platfrom/login/cctv_login_jump.vue'
  )

// 以下是共用路由文件
import ChannelComRouterMode from '@router/channelComRouterMode/index'

const {
  PlatfromHome_RouterMode,
  AutoExportPng_RouterMode,
  NotFind404_RouterMode,
  football_FIFAWC_RouterMode,
  football_FIFAWCQAZ_RouterMode,
  marathon_RouterMode,
  compreSportsMeet_WUSG_RouterMode,
  compreSportsMeet_ASG_RouterMode,
  compreSportsMeet_SOG_RouterMode,
  compreSportsMeet_AWG_RouterMode,
  compreSportsMeet_NSG_RouterMode,
  compreSportsMeet_WOG_RouterMode,
  basketball_CBA_RouterMode,
  badminton_thomasAndUber_RouterMode,
  compreSportsMeet_chinaOpen_RouterMode,
  dataPoster_default_RouterMode,
  football_FBLCSL_RouterMode,
  badminton_sudirman_RouterMode,
  basketball_FIBAWA_RouterMode,
} = ChannelComRouterMode

const mixtmtRouter = [
  {
    path: '/', //平台默认页
    redirect: '/loginJump/index',
    // redirect: '/home/index',
  },
  {
    path: '/loginJump/index', //平台跳转登录
    name: 'platfromLoginJumpIndex',
    component: PlatfromLoginJumpIndex,
  },
  {
    path: '/login/index', //平台登录页
    name: 'platfromLoginIndex',
    component: PlatfromLoginIndex,
  },
  PlatfromHome_RouterMode,
  AutoExportPng_RouterMode,
  NotFind404_RouterMode,
  football_FIFAWC_RouterMode,
  football_FIFAWCQAZ_RouterMode,
  marathon_RouterMode,
  compreSportsMeet_WUSG_RouterMode,
  compreSportsMeet_ASG_RouterMode,
  compreSportsMeet_SOG_RouterMode,
  compreSportsMeet_AWG_RouterMode,
  compreSportsMeet_NSG_RouterMode,
  compreSportsMeet_WOG_RouterMode,
  basketball_CBA_RouterMode,
  badminton_thomasAndUber_RouterMode,
  compreSportsMeet_chinaOpen_RouterMode,
  dataPoster_default_RouterMode,
  football_FBLCSL_RouterMode,
  badminton_sudirman_RouterMode,
  basketball_FIBAWA_RouterMode,
]

export default {
  router: mixtmtRouter,
}
